import React, { useContext } from 'react';
import { StyleContext } from '@theme/AppStyles';

const IconCredits = ({size = 24}) => {
  const [style] = useContext(StyleContext);
  const color = style.palette.textPrimary;
  const colorHighlight = style.palette.accentPrimary;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill={color} d="M12,23C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z M12,3c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S17,3,12,3z"/>
      <path fill={colorHighlight} d="M12.5,6.4c2.7,0,4,1.5,4,1.5l-1.2,2c0,0-1.2-1.1-2.7-1.1c-2.1,0-3,1.5-3,3.1s1.1,3.2,3,3.2c1.6,0,2.9-1.3,2.9-1.3l1.4,1.9
		c0,0-1.5,1.8-4.3,1.8c-3.5,0.1-5.8-2.3-5.8-5.5S9.2,6.4,12.5,6.4z"/>
    </svg>
  )
}

export default IconCredits;